import React, { useEffect, useState } from 'react';
import { Container, Main } from './styles';
import api from './../../services/api';
import { ca } from 'date-fns/locale';

export const Video = ({ query, primaryColor }) => {
  const [video, setVideo] = useState();

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const companyVideoUrl =
        label && page_label
          ? `pages/sections/company-video/get/${label}/${page_label}`
          : `pages/sections/company-video/get/${label}`;
      
      try {
        const { data } = await api.get(companyVideoUrl);

        // Verificação de segurança para evitar erros quando data é undefined
        if (data && data.data) {
          // Tenta acessar data.data.data primeiro, depois data.data
          const videoData = data.data.data || data.data;
          setVideo(videoData);
        } else {
          console.warn('API response data structure is invalid in Video component:', data);
          setVideo({});
        }
      } catch (error) {
        console.error('Error loading video data:', error);
        setVideo({});
      }
    }

    let isMoutend = true;

    if (isMoutend && query) {
      load();
    }

    return () => {
      isMoutend = false;
    };
  }, [query]);

  return (
    <Main id="companyVideo" actived={video?.active}>
      <Container primaryColor={primaryColor}>
        <iframe src={video?.embed} title="Company Video" />
      </Container>
    </Main>
  );
};
